<template>
  <div class="collection-topbar-meth">
    <div class="collection-topbar-meth-balance-wrapper">
      <div class="collection-topbar-meth-title">
        Total Claimable METH
      </div>
      <div class="collection-topbar-meth-balance">
        {{ totalClaimableMeth }} METH
      </div>
    </div>
    <div
      v-if="totalClaimableMeth > 0"
      class="collection-topbar-meth-claim-wrapper"
    >
      <button
        class="collection-topbar-meth-claim"
        :class="{ disabled: claimDisabled }"
        @click="claimMethAll"
      >
        <span class="collection-topbar-meth-claim-row">
          Claim all
          <IInfo width="12" />
        </span>
        <span
          v-if="includeMethBank"
          class="collection-topbar-meth-claim-bank"
        >METH Bank: included</span>
        <span
          v-else
          class="collection-topbar-meth-claim-bank"
        >METH Bank: not included</span>
      </button>
      <div class="collection-topbar-meth-claim-tooltip">
        Gas fees will be slightly higher the first time you interact with our
        updated orchestrator contract. This updated contract enables new utility
        for Bulls and God Bulls.
        <br>The next time you claim METH on the updated orchestrator contract the
        gas fees would be back to normal and most likely be lower than
        previously expected on account of our updated orchestrator contract
        being very gas efficient.
      </div>
      <div class="collection-topbar-meth-claim-info">
        From all collections and METH Bank
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "@/composables/useToast";
import { claimTokensAndMethBankMeth } from "@/functions/claimTokensAndMethBankMeth";
import { useMethBankStore } from "@/store/meth-bank";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import IInfo from "../../assets/img/info.svg?inline";


export default {
  components: { IInfo },
  data() {
    return {};
  },
  computed: {
    totalClaimableMeth() {
      const totalMeth = useWalletCollectionStore().totalClaimableMeth + useMethBankStore().balance
      return totalMeth > 0 ? `+${totalMeth}` : 0;
    },
    includeMethBank() {
      return useMethBankStore().canClaimNow
    },
    claimDisabled() {
      if (!this.totalClaimableMeth) return true
      if (!this.includeMethBank && !useWalletCollectionStore().totalClaimableMeth) return true
      return false
    }
  },
  methods: {
    async claimMethAll() {
      if (useWeb3Store().safeClaim.isController) {

        useToast().error({ title: "You can claim only harvested METH in SafeClaim mode" })
        return
      }
      await claimTokensAndMethBankMeth()
    }
  },
};
</script>
